import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';

import { editarEstadoExpediente } from '../../../actions/mesaEntrada/mesaEntradaActions';
import { MESA_ENTRADA_COMPROBANTES_ESTADOS, MESA_ENTRADA_GESTION_BUTTONS } from '../../../utils/constants';

const options = ['Enviar Comprobantes', 'Modificar Destino', 'Retornar Comprobantes'];

export const GestionComprobanteButtons = ({formValues, selected, setSelected, handleOpenModal, estadoComprobante}) => {
    const dispatch = useDispatch();

    const [open, setOpen] = React.useState(false);
    const anchorRef = React.useRef(null);
    const [selectedIndex, setSelectedIndex] = React.useState(MESA_ENTRADA_GESTION_BUTTONS.MODIFICAR_DESTINO);
    const estado ={
        pendiente: estadoComprobante === MESA_ENTRADA_COMPROBANTES_ESTADOS.PENDIENTE_ENVIO?.toString(),
        anulada: estadoComprobante === MESA_ENTRADA_COMPROBANTES_ESTADOS.ANULADA?.toString(),
        enviada: estadoComprobante === MESA_ENTRADA_COMPROBANTES_ESTADOS.ENVIADA?.toString(),
        proforma: estadoComprobante === MESA_ENTRADA_COMPROBANTES_ESTADOS.PROFORMA?.toString(),
    }

    const handleClick = (e, expedientes) => {
        e.preventDefault();
        if(selectedIndex === MESA_ENTRADA_GESTION_BUTTONS.ENVIAR){
            dispatch(editarEstadoExpediente({expedientes, observacion: ""}, formValues, setSelected));
        }else{
            handleOpenModal(e, 
                selectedIndex === MESA_ENTRADA_GESTION_BUTTONS.MODIFICAR_DESTINO
                ? {idExpediente: selected, action: MESA_ENTRADA_GESTION_BUTTONS.MODIFICAR_DESTINO} 
                : {expedientes, formValues, setSelected}
            );
        }
    };

    const handleMenuItemClick = (event, index) => {
        setSelectedIndex(index);
        setOpen(false);
    };

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
        return;
        }
        setOpen(false);
    };

    useEffect(() => {
        if(estado.pendiente || estado.anulada || estado.proforma)
            setSelectedIndex(MESA_ENTRADA_GESTION_BUTTONS.ENVIAR)
        else
            setSelectedIndex(MESA_ENTRADA_GESTION_BUTTONS.RETORNAR)
    }, [estadoComprobante])
    
    
    return (
        <Grid container direction="column" alignItems="center">
        <Grid item xs={12}>
            <ButtonGroup variant="contained" color="primary" ref={anchorRef} aria-label="split button">
            <Button 
                onClick={e => handleClick(e, selected)} 
                disabled={
                    estado.anulada ||
                    ((selectedIndex !== MESA_ENTRADA_GESTION_BUTTONS.RETORNAR && estado.enviada) || selected.length === 0) ||
                    ((selectedIndex === MESA_ENTRADA_GESTION_BUTTONS.RETORNAR && estado.pendiente) || selected.length === 0)
                }
            >{options[selectedIndex]}</Button>
            <Button
                color="primary"
                size="small"
                aria-controls={open ? 'split-button-menu' : undefined}
                aria-expanded={open ? 'true' : undefined}
                aria-label="select merge strategy"
                aria-haspopup="menu"
                onClick={handleToggle}
                disabled={estado.anulada || estado.proforma}
            >
                <ArrowDropDownIcon />
            </Button>
            </ButtonGroup>
            <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal style={{zIndex:1}}>
            {({ TransitionProps, placement }) => (
                <Grow
                {...TransitionProps}
                style={{
                    transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
                }}
                >
                <Paper>
                    <ClickAwayListener onClickAway={handleClose}>
                    <MenuList id="split-button-menu">
                        {options.map((option, index) => (
                        <MenuItem
                            key={option}
                            disabled={
                                estado.anulada ||
                                (index !== MESA_ENTRADA_GESTION_BUTTONS.RETORNAR && estado.enviada) ||
                                (index === MESA_ENTRADA_GESTION_BUTTONS.RETORNAR && estado.pendiente)
                            }
                            selected={index === selectedIndex}
                            onClick={(event) => handleMenuItemClick(event, index)}
                        >
                            {option}
                        </MenuItem>
                        ))}
                    </MenuList>
                    </ClickAwayListener>
                </Paper>
                </Grow>
            )}
            </Popper>
        </Grid>
        </Grid>
    );
}